import type { ComputePositionReturn } from '@floating-ui/dom';
import createFloating, { FloatingOptions } from './createFloating';
import createPortalFloating from './createPortalFloating';

export type FloatingWithArrowOptions = {
  $floating: HTMLElement,
  $reference: HTMLElement,
  centeredArrows?: boolean,
  usePortal?: boolean,
  onCalculate?: (result: ComputePositionReturn) => void,
};

const createFloatingWithArrow = async ({
  $floating,
  $reference,
  centeredArrows = true,
  usePortal = false,
  onCalculate,
}: FloatingWithArrowOptions) => {
  $floating.classList.add('u-floating');

  const floatingOptions: FloatingOptions = {
    $reference,
    $floating,
    $arrow: document.createElement('span'),
    strategy: 'fixed',
    rootBoundary: 'viewport',
    onCalculate(result) {
      const {
        placement,
        middlewareData: { arrow },
      } = result;

      $floating.dataset.placement = placement;

      $floating.style.setProperty('--floating-inset-inline-start', `${result.x}px`);
      $floating.style.setProperty('--floating-inset-block-start', `${result.y}px`);

      if (centeredArrows && arrow?.x) {
        $floating.style.setProperty('--floating-triangle-offset-x', `${arrow.x}px`);
      } else {
        $floating.style.setProperty('--floating-triangle-offset-x', '20px');
      }

      if (centeredArrows && arrow?.y) {
        $floating.style.setProperty('--floating-triangle-offset-y', `${arrow.y}px`);
      } else {
        $floating.style.setProperty('--floating-triangle-offset-y', '20px');
      }

      onCalculate?.(result);
    },
  };

  return usePortal ? createPortalFloating(floatingOptions) : createFloating(floatingOptions);
};

export default createFloatingWithArrow;
